import React from "react";
import "./Confirm_Add_to_Cart.css";
import Designs_uploaded from "./Designs_uploaded/Designs_uploaded";
import Standard_Visiting_Info_Cards from "./Standard_Visiting_Info_Cards/Standard_Visiting_Info_Cards";
import Order_Process_OrderSummary from "./Order_Process_OrderSummary/Order_Process_OrderSummary";

function Confirm_Add_to_Cart({data}) {
  return (
    <>
      <section className="Confirm_Add_to_Cart">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            <Standard_Visiting_Info_Cards data={data}/>
          </div>

          <div className="col-lg-4 col-md-12">
            <Order_Process_OrderSummary data={data}/>
          </div>

          <div className="col-12">
            <Designs_uploaded data={data}/>
          </div>
        </div>
      </section>
    </>
  );
}

export default Confirm_Add_to_Cart;
